import script from "./PiChart.vue?vue&type=script&lang=js"
export * from "./PiChart.vue?vue&type=script&lang=js"

export default script